import { DateTime_fromTransferable, DateTime_toTransferable, Duration_fromTransferable, Duration_toTransferable, } from "./DateTime";
import { Area } from "./Area";
export var Aggregate;
(function (Aggregate) {
    Aggregate["min"] = "min";
    Aggregate["max"] = "max";
    Aggregate["mean"] = "mean";
    Aggregate["median"] = "median";
    Aggregate["mode"] = "mode";
    Aggregate["integral"] = "integral";
})(Aggregate || (Aggregate = {}));
export function PolygonRequest_toTransferable(req) {
    return {
        ...req,
        // TODO Maybe use enum instead
        aggregate: req.aggregate,
        startDatetime: DateTime_toTransferable(req.startDatetime),
        duration: req.duration ? Duration_toTransferable(req.duration) : undefined,
        temporalResolution: req.temporalResolution
            ? Duration_toTransferable(req.temporalResolution)
            : undefined,
        boundingBoxLimit: req.boundingBoxLimit
            ? req.boundingBoxLimit.toTransferable()
            : null,
    };
}
export function PolygonRequest_fromTransferable(req) {
    return {
        ...req,
        aggregate: req.aggregate,
        startDatetime: DateTime_fromTransferable(req.startDatetime),
        duration: req.duration
            ? Duration_fromTransferable(req.duration)
            : undefined,
        temporalResolution: req.temporalResolution
            ? Duration_fromTransferable(req.temporalResolution)
            : undefined,
        boundingBoxLimit: req.boundingBoxLimit
            ? Area.fromTransferable(req.boundingBoxLimit)
            : null,
    };
}
//# sourceMappingURL=PolygonRequest.js.map